import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const plans = [
  {
    name: 'Free',
    price: { monthly: 0, yearly: 0 },
    icon: 'fa-paper-plane',
    color: '#0066FF',
    bg: '#e8f0ff',
    tag: null,
    features: [
      '3 Job Postings / month',
      'Basic Job Listing',
      'Email Applications',
      'Standard Support',
      '30-day Listing Duration',
    ],
    disabled: ['Featured Badge', 'Priority Placement', 'Analytics Dashboard', 'Dedicated Manager'],
  },
  {
    name: 'Premium',
    price: { monthly: 49, yearly: 39 },
    icon: 'fa-crown',
    color: '#f59e0b',
    bg: '#fff8e6',
    tag: 'Most Popular',
    features: [
      '20 Job Postings / month',
      'Featured Job Badge',
      'Priority Placement',
      'Analytics Dashboard',
      '60-day Listing Duration',
      'Email & Chat Support',
    ],
    disabled: ['Dedicated Manager'],
  },
  {
    name: 'Super Premium',
    price: { monthly: 99, yearly: 79 },
    icon: 'fa-gem',
    color: '#8b5cf6',
    bg: '#f3eeff',
    tag: 'Best Value',
    features: [
      'Unlimited Job Postings',
      'Featured + Hot Badge',
      'Top Priority Placement',
      'Advanced Analytics',
      '90-day Listing Duration',
      '24/7 Priority Support',
      'Dedicated Account Manager',
    ],
    disabled: [],
  },
];

export default function Pricing() {
  const [yearly, setYearly] = useState(false);

  return (
    <>
      <PageHeader title="Pricing Plans" breadcrumb="Pricing" />

      <section className="section-pad">
        <div className="container">

          <div className="section-header">
            <span className="section-badge">Pricing</span>
            <h2 className="section-title">Choose Your Plan</h2>
            <p className="section-sub">Simple, transparent pricing for every business size</p>

            {/* Toggle */}
            <div className="pricing-toggle">
              <span className={!yearly ? 'active' : ''}>Monthly</span>
              <div className={`pricing-switch ${yearly ? 'on' : ''}`} onClick={() => setYearly(!yearly)}>
                <div className="pricing-switch-thumb"></div>
              </div>
              <span className={yearly ? 'active' : ''}>Yearly <span className="pricing-save-badge">Save 20%</span></span>
            </div>
          </div>

          <div className="pricing-cards">
            {plans.map((plan, i) => (
              <div key={i} className={`pricing-card ${plan.name === 'Premium' ? 'pricing-card-popular' : ''}`}>
                {plan.tag && <div className="pricing-tag">{plan.tag}</div>}

                <div className="pricing-icon" style={{ background: plan.bg, color: plan.color }}>
                  <i className={`fa ${plan.icon}`}></i>
                </div>

                <h4 className="pricing-name">{plan.name}</h4>

                <div className="pricing-price">
                  {plan.price.monthly === 0 ? (
                    <><span className="pricing-amount">Free</span></>
                  ) : (
                    <>
                      <span className="pricing-currency">₹</span>
                      <span className="pricing-amount">{yearly ? plan.price.yearly : plan.price.monthly}</span>
                      <span className="pricing-period">/ mo</span>
                    </>
                  )}
                </div>

                <ul className="pricing-features">
                  {plan.features.map((f, j) => (
                    <li key={j} className="pricing-feature-on">
                      <i className="fa fa-check-circle" style={{ color: plan.color }}></i>
                      <span>{f}</span>
                    </li>
                  ))}
                  {plan.disabled.map((f, j) => (
                    <li key={j} className="pricing-feature-off">
                      <i className="fa fa-times-circle"></i>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/post-job"
                  className={plan.name === 'Premium' ? 'btn-grad w-100 justify-content-center' : 'btn-outline-grad w-100 justify-content-center'}
                  style={plan.name === 'Super Premium' ? { background: 'linear-gradient(135deg,#8b5cf6,#6d28d9)', border: 'none', color: '#fff' } : {}}
                >
                  {plan.price.monthly === 0 ? 'Get Started Free' : `Get ${plan.name}`}
                </Link>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}
